// src/hooks/useSizes.js
import { useEffect, useState } from 'react';

export function useSizes({ eventId, categoryId }) {
  const [sizes, setSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  // console.log('usesize ', eventId);

  useEffect(() => {
    let alive = true;
    async function run() {
      setLoading(true);
      setErr(null);
      try {
        // TODO: ganti ke endpoint kamu
        // console.log('usesize function ', eventId);
        // contoh: GET /api/events/:eventId/sizes?categoryId=201
        const res = await fetch(
          `${process.env.REACT_APP_IRACE_API_URL}/api/events/offlane/${eventId}/sizes?categoryId=${categoryId}`,
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        // console.log(json);
        // normalisasi serbaguna:
        // terima bentuk [{code:'S', label:'Small', index:0, type:'adult'}]
        const norm = (Array.isArray(json) ? json : []).map((s, i) => ({
          value: s.size,
          label: `${s.size} - Remaining: ${s.remainingLeft}`,
          disabled: Number(s.remainingLeft) <= 0,
        }));
        // console.log(norm);

        if (alive) setSizes(norm);
      } catch (e) {
        if (alive) setErr(e.message || 'Failed to load sizes');
      } finally {
        if (alive) setLoading(false);
      }
    }
    if (eventId && categoryId != null) run();
    return () => {
      alive = false;
    };
  }, [eventId, categoryId]);

  return { sizes, loading, err };
}
